export function cardsSlider() {
    if (typeof window.Flickity !== 'function') return;

    const sliders = [];
    let disposed = false;
    document.querySelectorAll('[data-cards-slider]').forEach((element) => {
        if (window.Flickity.data(element)) return;

        const slider = new window.Flickity(element, {
            cellSelector: '.cards__slide',
            cellAlign: 'left',
            contain: true,
            freeScroll: true,
            groupCells: false,
            friction: 0.4,
            accessibility: true,
            prevNextButtons: element.children.length > 1,
            pageDots: false,
        });

        const revealLeftEdge = (progress) => {
            if (progress <= 0 || !Number.isFinite(progress)) return;

            element.classList.add('has-scrolled');
            slider.off('scroll', revealLeftEdge);
        };

        slider.on('scroll', revealLeftEdge);

        sliders.push(slider);
        element.querySelectorAll('img').forEach((image) => {
            if (!image.complete) {
                image.addEventListener('load', () => { if (!disposed) slider.resize(); }, { once: true });
            }
        });

        document.fonts.ready.then(() => { if (!disposed) slider.resize(); });
    });
    return () => {
        disposed = true;
        sliders.forEach((slider) => slider.destroy());
    };
}
